import script from "./copyright.vue?vue&type=script&setup=true&lang=js"
export * from "./copyright.vue?vue&type=script&setup=true&lang=js"

import "./copyright.vue?vue&type=style&index=0&id=04b3199c&lang=less&scoped=true"
import "./copyright.vue?vue&type=style&index=1&id=04b3199c&lang=less"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b3199c"]])

export default __exports__